import { PopupComponent } from './popup.component';

export default angular
  .module('sfMobile.components.popup', [])
  .component('sfPopup', PopupComponent).name;
